import { ModuleWithProviders, NgModule } from "@angular/core";
import { AdobeAnalyticsDirective } from "../directives/adobe-analytics.directive";
import { IAdobeAnalyticsConfig } from "../models/adobe-analytics.model";
import { AdobePageLoadDataResolverService } from "../resolvers/adobe-page-load-data-resolver.service";
import { AdobeAnalyticsService } from "../services/adobe-analytics.service";
import { ADOBE_ANALYTICS_CONFIG } from "../utils";

@NgModule({
    declarations: [AdobeAnalyticsDirective],
    imports: [],
    exports: [AdobeAnalyticsDirective],
    providers: [AdobePageLoadDataResolverService]
})
export class AdobeAnalyticsModule {
    public static forRoot(config: IAdobeAnalyticsConfig): ModuleWithProviders<AdobeAnalyticsModule> {
        return {
            ngModule: AdobeAnalyticsModule,
            providers: [
                {
                    provide: ADOBE_ANALYTICS_CONFIG,
                    useValue: config
                },
                AdobeAnalyticsService
            ]
        };
    }
}
